module.exports = __webpack_public_path__ + "assets/img/bg.2c0645f4.png";